import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { P1, P2, P3 } from 'assets/fonts';

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function SimpleModal(props) {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);


  const body = (
    <div style={modalStyle} className={classes.paper}>
      <P1 id="simple-modal-title">Congratulations!</P1>
      <P2 id="simple-modal-description">
        You have submitted this questionnaire successfully.
      </P2>
      <P3>(Click away to dismiss this message)</P3>
      <SimpleModal />
    </div>
  );

  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.onClose}
      >
        {body}
      </Modal>
    </div>
  );
}
